export const STRINGS = {
    labelJumpToPage: (page) => interpolate(gettext('Page %(page)s'), { page }, true),
    labelLegend: (firstRowOnPage, lastRowOnPage, totalRows) => interpolate(
        gettext('Showing %(first)s – %(last)s of %(total)s'),
        { first: firstRowOnPage, last: lastRowOnPage, total: totalRows },
        true
    ),
    labelRowsPerPage: (rowsPerPage) => interpolate(gettext('%(count)s per page'), { count: rowsPerPage }, true),
};
